// extracted by mini-css-extract-plugin
export default {"container":"modal_scrollable_content-module__container--32qv6"};